import React from "react"
import { createIcon } from "@chakra-ui/icons"

const Minus = createIcon({
  displayName: "Minus",
  viewBox: "0 0 448 512",
  path: (
    <path
      d="M432 256c0 8.8-7.2 16-16 16H32c-8.844 0-16-7.15-16-15.99C16 247.2 23.16 240 32 240h384c8.8 0 16 7.2 16 16z"
      fill="currentColor"
    />
  ),
})

export default Minus
